module.exports = __webpack_public_path__ + "static/media/ENCONTRO_4_ED_FISICA.56edc787.pdf";